export enum ProcedureTypes{
	Data = "Data", 
	Action = "Action",
	IfElseControl = "IfElse", 
	IfControl = "If", 
	ElseControl = "Else",
	ForLoopControl = "For Loop",
	Function = "Function"
}



// WEBPACK FOOTER //
// C:/Users/Akshata/Documents/GitHub/mobius-dev/src/app/base-classes/procedure/ProcedureTypes.ts